import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { EnvProvider } from "./context/EnvContext";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./routes/PrivateRoute";
import HomeRedirect from "./routes/homeRedirect";
import { PageProvider } from "./context/PageContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CartProvider } from "./context/CartContext";
import { ProductFilterProvider } from "./context/ProductFilterContext";
import { OrderProvider } from "./context/OrderContext";
import { SeasonalProvider } from "./context/SeasonalContext";
import { TopSellersProvider } from "./context/TopSellersContext";
import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import MainNav from "./components/MainNav";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function App() {
  return (
    <EnvProvider>
      <AuthProvider>
        <Router
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <OrderProvider>
            <CartProvider>
              <ProductFilterProvider>
                <SeasonalProvider>
                  <TopSellersProvider>
                    <PageProvider>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MainNav />
                        <Routes>
                          <Route path="/" element={<HomeRedirect />} />
                          <Route path="/home" element={<Home />} />
                          <Route path="/login" element={<LoginPage />} />
                          <Route path="/reset-password" element={<ResetPasswordPage />} />
                          <Route
                            path="/dashboard"
                            element={
                              <PrivateRoute>
                                <Dashboard />
                              </PrivateRoute>
                            }
                          />
                          <Route path="*" element={<HomeRedirect />} />
                        </Routes>
                      </LocalizationProvider>
                    </PageProvider>
                  </TopSellersProvider>
                </SeasonalProvider>
              </ProductFilterProvider>
            </CartProvider>
          </OrderProvider>
        </Router>
      </AuthProvider>
    </EnvProvider>
  );
}

export default App;
